import { Box, Grid } from "@mui/material";
import ThemeContext from "components/app/Context";
import Feedback from "components/common/Feedback";
import { filterPage } from "components/common/Filters/FiltersHelper";
import NoPlansBanner from "components/common/NoPlansBanner";
import Scroller from "components/common/Scroller/InfiniteScroller";
import Spinner from "components/common/Spinner/Spinner";
import { isEmpty } from "lodash";
import { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { PAGE_SIZE } from "utils/CommonConstants";
import { convertArrayValuesToString, formFilterRequestPayload } from "utils/CommonFunctions";
import { pageNames } from "utils/Types";
import TableHeader from "./TableHeader";
import Item from "./item";
import { clearMyPlanList, fetchMyPlansAsync, fetchOwnerDetailsAsync } from "./myplans.slice";

function List() {
  const dispatch = useAppDispatch();
  const { isMobileScreen } = useContext(ThemeContext);

  const [searchParams] = useSearchParams();
  const searchText = searchParams.get("search") || "";

  const [pageNo, setPageNo] = useState(0);

  const myPlansList = useAppSelector((state) => state?.myplans.MyPlans.list);
  const isLoading = useAppSelector((state) => state?.myplans.MyPlans.status);
  const totalRecords = useAppSelector((state) => state.myplans.MyPlans.totalRecords);
  const { isCorp, isAbovePropertyUser, isAbovePropertyUserFetched } = useAppSelector(
    (state) => state.app.loggedInUserDetails
  );
  const globalFiltersforPage = useAppSelector(
    (state) => state.globalFilters[isCorp ? filterPage.consultantInncodePlansDisplay : filterPage.inncodePlansDisplay]
  );
  const filterRequestPayload = globalFiltersforPage?.modifiedFilter || globalFiltersforPage?.defaultFilter || [];
  const formattedFilterRequestPayload = formFilterRequestPayload(filterRequestPayload, convertArrayValuesToString);

  useEffect(() => {
    const shouldFetchPlans = isCorp
      ? !(isEmpty(formattedFilterRequestPayload.innCode) && isEmpty(formattedFilterRequestPayload.searchedHltId))
      : true;

    if (shouldFetchPlans) {
      const getPlans = async () => {
        let planOwners: [] = [];
        const props = {
          page: 0,
          size: PAGE_SIZE,
          searchText: searchText,
          ...formattedFilterRequestPayload
        };

        const fetchPlans = await dispatch(fetchMyPlansAsync(props));
        planOwners = fetchPlans?.payload?.meta?.owners;
        if (planOwners?.length > 0) {
          const data = {
            value: planOwners,
            size: planOwners.length
          };
          dispatch(fetchOwnerDetailsAsync(data));
        }
      };
      if (isAbovePropertyUserFetched && !isAbovePropertyUser) {
        getPlans();
      }
    } else {
      dispatch(clearMyPlanList());
    }

    setPageNo(0);
  }, [dispatch, filterRequestPayload, searchText, isCorp, isAbovePropertyUser, isAbovePropertyUserFetched]);

  const fetchMore = () => {
    const props = {
      page: pageNo + 1,
      size: PAGE_SIZE,
      searchText: searchText,
      ...formattedFilterRequestPayload
    };
    dispatch(fetchMyPlansAsync(props));
    setPageNo(pageNo + 1);
  };

  return (
    <>
      <Feedback form="fetchMyPlans" />

      {!isMobileScreen && <TableHeader />}
      {isLoading === "idle" || pageNo > 0 ? (
        <Grid container marginTop={isMobileScreen ? "-40px" : "0px"}>
          {myPlansList?.length ? (
            <Scroller dataLength={myPlansList.length} loadMore={fetchMore} totalList={totalRecords} label="Plans">
              {myPlansList.map((plan: any) => {
                return <Item key={plan.id} plan={plan} />;
              })}
            </Scroller>
          ) : (
            <NoPlansBanner pageName={pageNames.myPlans} />
          )}
        </Grid>
      ) : (
        <Box width={"500px"} marginTop={"100px"}>
          <Spinner backdropVisible />
        </Box>
      )}
    </>
  );
}

export default List;
